<template>
    <section>
        <el-tabs v-model="activeName" type="card">
            <!--open list-->
            <el-tab-pane label="To Confirm" name="first">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.confirmInboundFilter" placeholder="Offer" clearable @keyup.enter.native="getNurseConfirmList">
                                <el-button slot="append" icon="el-icon-search" @click="getNurseConfirmList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportNurseToConfirm','toConfirm.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="confirmInbound" highlight-current-row v-loading="firstListLoading" style="width: 100%;">
                    <el-table-column prop="inboundNo" label="#">
                    </el-table-column>
                    <el-table-column label="Product" width="300px">
                        <template slot-scope="scope">
                            {{scope.row.productName}}
                            <p class="note">{{scope.row.createDate}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="company" label="Company" >
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qty" label="Qty" >
                    </el-table-column>
                    <el-table-column prop="leftNum" label="Left" >
                    </el-table-column>
                    <el-table-column prop="price" label="Price" >
                    </el-table-column>
                    <el-table-column label="Action" width="180px">
                        <template slot-scope="scope">
                            <el-button size="small" @click="confirmInboundItem(scope.row.inboundNo,'self',true)" v-if="scope.row.isDoctor===1">Confirm
                            </el-button>
                            <el-button size="small" @click="confirmInboundItem(scope.row.inboundNo,'warehouse',true)" v-if="scope.row.isDoctor===0">
                                Confirm
                            </el-button>
                            <el-button size="small" type="danger" @click="showCancelInbound(scope.row.inboundNo)">Cancel</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeConfirmInboundPage" :page-size="pageSize" :total="confirmInboundTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
            <!--Groups list-->
            <el-tab-pane label="Reported" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.reportFilter" placeholder="Offer" clearable @keyup.enter.native="getReportList">
                                <el-button slot="append" icon="el-icon-search" @click="getReportList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="filters.reportStatus" clearable @change="getReportList">
                                <el-option label="Pending" value="0"></el-option>
                                <el-option label="Rejected" value="2"></el-option>
                                <el-option label="Confirmed" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportNurseReported','report.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="reportedInbound" highlight-current-row v-loading="secondListLoading" style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="product" label="Offer">
                        <template slot-scope="scope">
                            <p>{{scope.row.productName}} ({{scope.row.offerCreateDate}})</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user" label="User">
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="quantity" label="Qty">
                    </el-table-column>
                    <el-table-column label="Status">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status===0"><el-tag type="info">Pending</el-tag></p>
                            <p v-if="scope.row.status===1"><el-tag type="success">Confirmed</el-tag></p>
                            <p v-if="scope.row.status===2"><el-tag type="danger">Rejected</el-tag></p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="Report Date">
                    </el-table-column>
                    <el-table-column prop="note" label="Note">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeReportPage" :page-size="20" :total="total"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <!--Invitations list-->
            <el-tab-pane label="Inbound History" name="third">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.historyFilter" placeholder="Offer" clearable @keyup.enter.native="getInboundHistoryList">
                                <el-button slot="append" icon="el-icon-search" @click="getInboundHistoryList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportNurseInboundHistory','inboundHistory.xls')">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="inboundHistory" highlight-current-row v-loading="thirdListLoading" 
                          style="width: 100%;">
                    <el-table-column prop="id" label="#">
                    </el-table-column>
                    <el-table-column prop="productName" label="Offer" >
                    </el-table-column>
                    <el-table-column prop="doctorName" label="Company" >
                    </el-table-column>
                    <el-table-column prop="price" label="Price" >
                    </el-table-column>
                    <el-table-column prop="quantity" label="Qty" >
                    </el-table-column>
                    <el-table-column label="Warehouse" >
                        <template slot-scope="scope">
                            <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tracking" label="Tracking" >
                    </el-table-column>
                    <el-table-column prop="offerCreateDate" label="Offer Create Date" >
                    </el-table-column>
                    <el-table-column prop="inboundDate" label="Inbound Date" >
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeHistory" :page-size="pageSize" :total="historyTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
        </el-tabs>

        <!--护士自己家的仓库入库confirm-->
        <el-dialog title="Confirm Inbound Items to self storage" width="80%" :visible.sync="selfConfirmVisible"
                   :close-on-click-modal="false">
            <el-form :model="selfConfirm" label-width="220px" :rules="inboundFormRules" ref="selfConfirm">
                <el-form-item label="Product Name">
                    <el-input v-model="selfConfirm.productName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Company">
                    <el-input v-model="selfConfirm.company" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Price">
                    <el-input-number v-model="selfConfirm.price" :min="0" :disabled="true"
                                     auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Total">
                    <el-input-number v-model="selfConfirm.num" :min="0" :disabled="true"
                                     auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Left">
                    <el-input-number v-model="selfConfirm.leftNum" :min="0" :disabled="true"
                                     auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Inbound quantity" prop="quantity">
                    <el-input-number v-model="selfConfirm.quantity" :min="0" auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Warehouse">
                    <el-input v-model="selfConfirm.warehouse" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="selfConfirmVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleConfirmInbound" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <!--神医仓库入库confirm-->
        <el-dialog title="Confirm Inbound Items to shared warehouse" width="80%" :visible.sync="warehouseConfirmVisible" v-loading.fullscreen.lock="modalLoading"
                   :close-on-click-modal="false">
            <el-form :model="warehouseConfirm" label-width="220px" :rules="addFormRules" ref="warehouseConfirm">
                <el-form-item label="Product Name">
                    <el-input v-model="warehouseConfirm.productName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Company">
                    <el-input v-model="warehouseConfirm.company" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Price">
                    <el-input-number v-model="warehouseConfirm.price" :min="0" :disabled="true" auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Total">
                    <el-input-number v-model="warehouseConfirm.num" :min="0" :disabled="true" auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Left">
                    <el-input-number v-model="warehouseConfirm.leftNum" :min="0" :disabled="true" auto-complete="off"></el-input-number>
                </el-form-item>
                <el-form-item label="Warehouse">
                    <el-input v-model="warehouseConfirm.warehouse" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <p>Import tracking number as
                    <el-button size="mini" type="primary" @click="textImportVisible=true">Text</el-button>
                    or
                    <el-button size="mini" @click="excelImportVisible=true" type="primary">Excel</el-button>
                </p>
                </el-form-item>
                <el-form-item label="Tracking Staus">
                    <el-select v-model="warehouseConfirm.trackingStatus" placeholder="Status" @change="changeTrackingFilterStatus">
                        <el-option label="All" value="All" ></el-option>
                        <el-option label="Claimed" value="Claimed" ></el-option>
                        <el-option label="Matched" value="Matched" ></el-option>
                        <el-option label="Unmatched" value="Unmatched" ></el-option>
                    </el-select>
                    <el-button type="primary" @click.native="bulkConfirm" v-loading="loading" v-if="warehouseConfirm.unClaimedList.length>0">Bulk Confirm</el-button>
                    <el-button type="warning" @click.native="bulkRemoveSelected" v-loading="loading" v-if="warehouseConfirm.unClaimedList.length>0 || warehouseConfirm.unMatchedList.length>0">Bulk Remove Seleted</el-button>
                    <el-button type="success" @click="goToMixedClaim" v-if="warehouseConfirm.unMatchedList && warehouseConfirm.unMatchedList.length > 0" style="margin-left: 10px;">
                        <i class="fa fa-cubes" style="margin-right: 5px;"></i>Go to Mixed Claim
                    </el-button>
                    <!--<div v-if="warehouseConfirm.trackingNumbers.length==0">
                        <p style="padding: 0;margin: 0;font-size: 18px;color: #11b95c">You have not uploaded tracking
                            number, please upload tracking number.</p>
                    </div>-->
                    
                    <!-- Mixed Package Claim hint - moved to after buttons -->
                    <div v-if="warehouseConfirm.unMatchedList && warehouseConfirm.unMatchedList.length > 0" style="margin: 15px 0;">
                        <el-alert
                            title="Tracking numbers not found in warehouse records"
                            type="warning"
                            :closable="false"
                            show-icon>
                            <div slot="description">
                                Some tracking numbers couldn't be matched with existing warehouse records. This might be a mixed package containing multiple items from different orders. Use the "Go to Mixed Claim" button above to claim specific items.
                            </div>
                        </el-alert>
                    </div>
                    
                    <div>
                        <el-table stripe :data="warehouseConfirm.trackingNumbersPage" 
                            @selection-change="handleSelectionChange"
                            highlight-current-row v-loading="listLoading" style="width: 100%;">
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column label="#">
                                <template slot-scope="scope" >
                                    <span v-if="scope.row.inboundDetailId">{{scope.row.inboundDetailId}}</span>
                                    <span v-else-if="scope.row.importId">{{scope.row.importId}}</span>
                                    <span v-else>{{scope.$index + 1}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="tracking" label="Tracking Number">
                            </el-table-column>
                            <el-table-column prop="qty" label="Qty">
                            </el-table-column>
                            <el-table-column label="Action">
                                <template slot-scope="scope" >
                                    <div v-if="!scope.row.confirmed">
                                        <el-button size="small" type="primary"
                                                   v-if="scope.row.matched && scope.row.canClaim !== false"
                                                   :loading="scope.row.loading"
                                                   @click="claim(scope.row)">Claim
                                        </el-button>
                                        <el-button size="small" type="warning"
                                                   v-if="scope.row.matched && scope.row.canClaim === false"
                                                   disabled
                                                   title="UPC不匹配，无法认领">UPC不匹配
                                        </el-button>
                                        <el-button size="small" type="danger" @click="removeRow(scope.row)">Remove
                                        </el-button>
                                    </div>
                                    <div v-else>
                                        claimed
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-col :span="24" class="toolbar">
                            <el-pagination layout="prev, pager, next" @current-change="changeImportTrackingPage" :current-page="warehouseConfirm.currentPage" :page-size="100" :total="warehouseConfirm.total"
                                           style="float:right;">
                            </el-pagination>
                        </el-col>
                    </div>

                    <!--                    <el-input type="" v-model="warehouseConfirm.trackingNum" type="textarea" rows="5" auto-complete="off"></el-input>-->
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="warehouseConfirmVisible = false">Close</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Import tracking number from text" width="80%" :visible.sync="textImportVisible" v-loading.fullscreen.lock="modalLoading"
                   :close-on-click-modal="false">
            <el-form :model="warehouseConfirm" label-width="220px" :rules="addFormRules" ref="addForm">
                <el-input type="textarea" rows="10" v-model="text" :placeholder="placeholder" auto-complete="off"></el-input>
                <p class="note">The tracking number import of text needs to contain tracking Numbers, multiple records must be separated by newline.</p>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="textImportVisible = false">Close</el-button>
                <el-button type="primary" @click.native="importFromText" :loading="loading">Import</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Import tracking number from excel" width="80%" :visible.sync="excelImportVisible" v-loading.fullscreen.lock="modalLoading"
                   :close-on-click-modal="false">
            <el-upload style="width: 100%;" ref="upload" :on-progress="preview" :on-success="uploadSuccess" :on-error="uploadError" name="filename" drag :action="uploadUrl" :headers="headers" :data="uploadData" :limit="1" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text"><em>click to upload</em> or drag and drop file</div>
                <div class="el-upload__tip" slot="tip">Only allowed .xls,.xlsx files, please follow the columns format with trackingNum. include the header.</div>
            </el-upload>
        </el-dialog>
        <el-dialog title="Cancel Inbound" width="80%" :visible.sync="cancelInboundVisible"
                   :close-on-click-modal="false">
            <el-form :model="cancel" label-width="220px" :rules="addFormRules" ref="addForm">
                <el-form-item label="Cancel Number">
                    <el-input-number v-model="cancel.cancelNum" :min="0" auto-complete="off"></el-input-number>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelInboundVisible = false">Close</el-button>
                <el-button type="primary" @click.native="cancelInbound" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="UnClaimed Tracking#" width="80%" :visible.sync="unClaimedTrackingVisiable"
                   :close-on-click-modal="false">
            <el-form  label-width="220px">
                <el-form-item label="Tracking #">
                    <el-input type="textarea" v-model="unClaimedTracking" rows="15"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="unClaimedTrackingVisiable = false">Close</el-button>
            </div>
        </el-dialog>
    </section>
</template>


<script>
    import util from '../../common/js/util'
    import {getDoctorMembers, getInvitations} from '../../api/memberService';
    import {bulkClaim,removeImportTracking, batchRemoveImportTracking,getUnClaimTracking,getQtyByTracking,claimTracking,getReportList, getInboundHistoryList, getNurseConfirmList,confirmNurseInbound,getInboundDetail,cancelNurseInbound, canTrackingBeClaimed} from "../../api/inboundService";
    import {getInventoryReportList} from "../../api/inventoryService";
    import {defaultPageSize,serverUrl} from "../../globalVar";
    import {postExportExcel} from "../../api/exportService";
    import ElButton from "element-ui/packages/button/src/button";
    import ElInput from "element-ui/packages/input/src/input";

    export default {
        components: {
            ElInput,
            ElButton},
        created(){
            this.$on('changeDoctor',(value) => {
                setTimeout(()=>{
                    this.getNurseConfirmList();
                    this.getInboundHistoryList();
                    this.getReportList();
                },300);
            });
        },
        data() {
            return {
                text:"",
                headers:{
                    Authorization:window.sessionStorage.getItem("authorization")
                },
                uploadUrl:serverUrl+"/multiExcel/batchNurseInboundExcelImport",
                placeholder:"trackNum\r\n" +
                "trackNum",
                currentCompany: "",
                activeName: "first",
                filters: {
                    reportStatus:"",
                    reportFilter:"",
                    historyFilter:"",
                    confirmInboundFilter:"",
                    name: ''
                },

                cancel:{
                    inboundNo:"",
                    cancelNum:0
                },

                loading:false,
                modalLoading:false,
                firstListLoading: false,
                secondListLoading:false,
                thirdListLoading:false,

                pageSize:defaultPageSize,

                historyPage:1,
                historyTotal:0,

                confirmInboundPage:1,
                confirmInboundTotal:0,

                reportPage:1,
                reportTotal:0,


                confirmInbound: [],
                reportedInbound: [],
                inboundHistory: [],
                total: 0,
                page: 1,
                listLoading: false,

                textImportVisible: false,
                excelImportVisible: false,
                cancelInboundVisible:false,
                unClaimedTrackingVisiable:false,

                selfConfirm: {
                    inboundNo:"",
                    productName:"",
                    company:"",
                    price:"",
                    num:"",
                    leftNum:"",
                    quantity:"",
                    warehouse:""

                },
                selfConfirmVisible: false,//编辑界面是否显示

                warehouseConfirm: {
                    confirmed:false,
                    loading:false,
                    inboundNo:"",
                    productName:"",
                    company:"",
                    price:"",
                    num:"",
                    leftNum:"",
                    quantity:"",
                    warehouse:"",
                    trackingNumbers: [],
                    trackingNumbersPage:[],
                    trackingStatus:"All",
                    unClaimedList:[],
                    claimedList:[],
                    unMatchedList:[],
                    bulkConfirmSize:0,
                    total:0,
                    currentPage:1
                },
                trackingNumbers:[],
                warehouseConfirmVisible: false,

                editLoading: false,

                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                inboundFormRules: {
                    quantity: [
                        {required: true, message: 'Inbound quantity is required.', trigger: 'blur'},
                        {required: true, message: 'Inbound quantity must more than 1.', trigger: 'blur'},
                        { validator: this.checkQuantity, trigger: 'blur' }
                    ]
                },
                addFormRules:{

                },
                uploadData:{
                    inboundNo:""
                },
                unClaimedTracking:"",
                removeMultipleSelection: "", // 需要删除的选中Tracking#

            }
        },
        methods: {
            goToMixedClaim() {
                // 获取第一个未匹配的tracking号，用于预填充Mixed Claim页面
                const firstUnmatchedTracking = this.warehouseConfirm.unMatchedList && this.warehouseConfirm.unMatchedList.length > 0 
                    ? this.warehouseConfirm.unMatchedList[0].tracking 
                    : '';
                
                // 关闭当前弹窗
                this.warehouseConfirmVisible = false;
                
                // 导航到Mixed Claim页面，并传递tracking号码
                this.$router.push({
                    path: '/mixedPackageClaim',
                    query: {
                        tracking: firstUnmatchedTracking
                    }
                });
                
                // 显示提示信息
                this.$message.info('Redirecting to Mixed Claim page. You can claim specific items from the package.');
            },
            preview(){
              this.modalLoading = true;
            },
            getUnClaimTracking(){
                let param = {
                    fkey:this.warehouseConfirm.inboundNo
                }
                getUnClaimTracking(param).then((data)=>{
                    if(data.status===200){
                        if(data.result.length>0){
                            this.unClaimedTracking = data.result.join("\n");
                            this.unClaimedTrackingVisiable = true;
                        }else{
                            this.$message.error("None UnClaimed Tracking # found.");
                        }
                    }else{
                        this.$message.error(data.message);
                    }
                })
            },
            exportExcel(url,fileName,type){
                let param = {
                    url:url,
                    fileName:fileName,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                }
                postExportExcel(param).then(function(){

                })
            },
            bulkConfirm(){
                this.modalLoading = true
                let param = {
                    inboundNo:this.warehouseConfirm.inboundNo,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                }
                bulkClaim(param).then((data)=>{
                    this.modalLoading = false
                    if(data.status==200){
                        if(data.result==true){
                            this.$message.success(data.message)
                        }else{
                            this.$message.error(data.message)
                        }
                        this.getInboundHistoryList();
                        this.confirmInboundItem(this.warehouseConfirm.inboundNo,'warehouse',false)
                        this.getNurseConfirmList();
                    }else{
                        this.$message.error(data.message)
                    }
                })
            },
            bulkRemoveSelected() {
                if (!this.removeMultipleSelection || this.removeMultipleSelection.trim() === "") {
                    this.$message.warning("Please select tracking numbers to remove.");
                    return;
                }
                this.$confirm("Are you sure to remove selected tracking#?", "Warning", {
                    type: "warning"
                }).then(() => {
                    let param = {
                        inboundNo: this.warehouseConfirm.inboundNo,
                        trackingNos: this.removeMultipleSelection,
                    };
                    this.modalLoading = true;
                    batchRemoveImportTracking(param).then((data) => {
                        setTimeout(()=>{
                            if (data.status === 200) {
                                if (data.result.length > 0) {
                                    this.$message.warning("Exist already claimed tracking#:" + data.result);
                                } else {
                                    this.$message.success("Success");
                                }
                                this.confirmInboundItem(this.warehouseConfirm.inboundNo,'warehouse',false).then(()=>{
                                    this.modalLoading = false;
                                })
                            }
                        },600)

                    })
                }).catch(() => {

                })
            },
            /**
             * 检查tracking是否可以被claim（UPC验证）
             */
            async checkTrackingClaimability(inboundNo) {
                try {
                    // 对未认领的tracking进行批量UPC验证
                    const checkPromises = this.warehouseConfirm.unClaimedList.map(async (item) => {
                        try {
                            const response = await canTrackingBeClaimed({
                                inboundNo: inboundNo,
                                tracking: item.tracking
                            });

                            if (response.status === 200) {
                                item.canClaim = response.result; // true/false
                            } else {
                                item.canClaim = false;
                                console.warn(`检查tracking ${item.tracking}失败:`, response.message);
                            }
                        } catch (error) {
                            item.canClaim = false;
                            console.error(`检查tracking ${item.tracking}异常:`, error);
                        }
                    });

                    await Promise.all(checkPromises);

                    // 更新页面显示 - 确保重新组合前清空数组，避免重复显示
                    this.warehouseConfirm.trackingNumbers = [
                        ...this.warehouseConfirm.unClaimedList,
                        ...this.warehouseConfirm.unMatchedList,
                        ...this.warehouseConfirm.claimedList
                    ];

                    this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice(0, 100);

                } catch (error) {
                    console.error('批量检查tracking UPC验证失败:', error);
                    // 发生错误时，默认允许claim（保持原有行为）
                    this.warehouseConfirm.unClaimedList.forEach(item => {
                        item.canClaim = true;
                    });
                }
            },

            claim(item){
                let param = {
                    inboundNo:this.warehouseConfirm.inboundNo,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                    tracking:item.tracking,
                    qty:item.qty
                }
                item.loading = true;
                this.modalLoading = true;
                return claimTracking(param).then((data)=>{
                    item.loading = false;
                    this.modalLoading = false;
                    if(data.status===200){
                        if(data.result){
                            this.$refs.warehouseConfirm.resetFields();
                            // this.getNurseConfirmList();
                            this.$message.success("Tracking# claim operation completed, quantity " + data.result + ".");
                            // this.warehouseConfirmVisible = false;
                        }else{
                            this.$message.success(data.message);
                            // this.warehouseConfirm.leftNum = this.warehouseConfirm.leftNum-item.qty;
                        }
                        this.getInboundHistoryList();
                        this.confirmInboundItem(this.warehouseConfirm.inboundNo,'warehouse',false)
                        this.getNurseConfirmList();
                        this.warehouseConfirm.bulkConfirmSize += 1;
                    } else {
                        this.$message.error(data.message);
                    }
                })
            },
            uploadSuccess(a){
                this.modalLoading = false;
                if(a.status===200){
                    // let existTrackings = [];
                    // let trackingNumbers = [];
                    // if(a.result.length==0){
                    //     this.$message.error("Tracking not exsit.");
                    //     this.excelImportVisible = false;
                    //     this.$refs.upload.clearFiles();
                    //     return;
                    // }
                    // for(let i=0;i<a.result.length;i++){
                    //     let exist = this.warehouseConfirm.trackingNumbers.find((item)=>{
                    //         return item.tracking===a.result[i].trackingNumber;
                    //     });
                    //     if(!exist){
                    //         trackingNumbers.push({note:a.result[i].note,qty:a.result[i].qty,upc:a.result[i].upc,tracking:a.result[i].trackingNumber,loading:false,confirmed:false});
                    //     }else{
                    //         existTrackings.push(a.result[i].trackingNumber);
                    //     }
                    // }
                    // this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(trackingNumbers);
                    // this.excelImportVisible = false;
                    // if(existTrackings.length>0){
                    //     this.$message.info("Tracking: "+existTrackings.join(",")+" claimed for this record.")
                    // }
                    this.confirmInboundItem(this.warehouseConfirm.inboundNo,'warehouse')
                    this.excelImportVisible = false;
                    this.$refs.upload.clearFiles();
                }else{
                    this.$message.error(a.message);
                    this.$refs.upload.clearFiles();
                }
            },
            uploadError(a){
                this.modalLoading = false;
                this.$message.error(a.message);
                this.$refs.upload.clearFiles();
            },
            changeHistory(val){
                this.historyPage = val;
                this.getInboundHistoryList();
            },
            showCancelInbound(inboundNo){
                this.cancel.inboundNo = inboundNo;
                this.cancelInboundVisible = true;
            },
            cancelInbound(){
                if(!this.cancel.cancelNum){
                    this.$message.error("Cancel quantity is required.");
                    return;
                }
                if(!this.cancel.cancelNum>0){
                    this.$message.error("Cancel quantity must more than one.");
                    return;
                }
                this.$confirm('Are you sure?', 'Warning', {
                    type: 'warning'
                }).then(() => {
                    cancelNurseInbound({inboundNo:this.cancel.inboundNo,cancelNum:this.cancel.cancelNum}).then((res)=>{
                        if(res.status===200){
                            this.$message.success(res.message);
                            this.getNurseConfirmList();
                            this.getInboundHistoryList();
                            this.cancel.cancelNum = 0;
                            this.cancel.inboundNo = "";
                            this.cancelInboundVisible = false;
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {

                });
            },
            checkQuantity(rule, value, callback) {
                if (!value>0) {
                    return callback(new Error('Inbound quantity must more than 1.'));
                }else if(value>this.selfConfirm.leftNum){
                    return callback(new Error("Inbound quantity can't more than left."));
                }else{
                    callback();
                }
            },
            handleConfirmInbound(){
                this.$refs.selfConfirm.validate((valid)=>{
                    if(valid){
                        this.loading=true;
                        let param = {
                            inboundNo:this.selfConfirm.inboundNo,
                            confirmNum:this.selfConfirm.quantity
                        };
                        confirmNurseInbound(param).then((res)=>{
                            this.loading=false;
                            if(res.status===200){
                                this.$message.success(res.message);
                                this.selfConfirmVisible = false;
                                this.$refs.selfConfirm.resetFields();
                                this.getNurseConfirmList();
                                this.getInboundHistoryList();
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                    }
                })
            },
            changeConfirmInboundPage(val){
                this.confirmInboundPage= val;
                this.getNurseConfirmList();
            },
            changeReportPage(val){
                this.reportPage = val;
                this.getReportList();
            },
            removeRow(row){
                this.$confirm("Are you sure?", "Warning", {
                    type: "warning"
                }).then(() => {
                    let param = {
                        inboundNo: this.warehouseConfirm.inboundNo,
                        tracking: row.tracking
                    };
                    this.modalLoading = true;
                    removeImportTracking(param).then((data) => {
                        setTimeout(()=>{
                            if (data.status === 200) {
                                this.$message.success(data.message);
                                this.confirmInboundItem(this.warehouseConfirm.inboundNo,'warehouse',false).then(()=>{
                                    this.modalLoading = false;
                                })
                            }
                        },600)

                    })
                }).catch(() => {

                })
            },
            importFromText(){
                this.loading = true;
                let text = this.text.trim();
                if(!text){
                    this.$message.error("Please enter import text.")
                    this.loading = false;
                    return;
                }
                let row = [];
                let existTrackings = [];
                let trackings = [];
                let lines = [];
                if(text.indexOf(" ")!=-1){
                    lines = text.split(" ");
                }else if(text.indexOf(",")!=-1){
                    lines = text.split(",");
                }else if(text.indexOf(";")!=-1){
                    lines = text.split(";");
                }else if(text.indexOf(":")!=-1){
                    lines = text.split(":");
                }else if(text.indexOf("\t")!=-1){
                    lines = text.split("\t");
                }else{
                    lines = text.split("\n");
                }

                lines.filter((line)=>{
                    return line.trim()!=='';
                }).forEach((line)=>{
                    let obj = {};
                    obj.tracking = line.trim();
                    // obj.loading = false;
                    // obj.confirmed  = false;
                    let exist = trackings.find((item)=>{
                        return item===obj.tracking;
                    });
                    if(!exist){
                        trackings.push(obj.tracking);
                    }else{
                        existTrackings.push(obj.tracking);
                    }
                });
                //this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(row);
                this.excelImportVisible = false;
                if(existTrackings.length>0){
                    this.$message.info("Duplicate tracking: "+existTrackings.join(","))
                    this.loading = false;
                    return;
                }
                let param = {
                    trackings:trackings.join(","),
                    inboundNo:this.warehouseConfirm.inboundNo
                }
                let resultTrackings = [];
                let existList = [];
                getQtyByTracking(param).then((data)=>{
                    this.loading = false;
                    if(data.status===200){
                        this.textImportVisible = false;
                        this.confirmInboundItem(this.warehouseConfirm.inboundNo,'warehouse')
                        // let result = data.result;
                        // result.forEach(item => {
                        //     trackings.splice(trackings.indexOf(item.tracking),1);
                        //     let exsit = this.warehouseConfirm.trackingNumbers.find((a)=>{
                        //         return a.tracking==item.tracking;
                        //     })
                        //     if(exsit){
                        //         existList.push(exsit.tracking);
                        //     }else{
                        //         resultTrackings.push({tracking:item.tracking,qty:item.qty,loading:false,confirmed:false})
                        //     }
                        // })
                        // this.warehouseConfirm.trackingNumbers = this.warehouseConfirm.trackingNumbers.concat(resultTrackings);
                        // this.text = "";
                        // this.textImportVisible = false;
                        // if(existList.length>0){
                        //     this.$message.error("Exist Tracking for:"+existList.join(", "))
                        // }
                        // if(trackings.length>0){
                        //     this.$message.error("Not Found Tracking for:"+trackings.join(", "))
                        // }
                    }else{
                        console.log(data);
                        this.$message.error(data.message);
                    }
                })

            },
            confirmInboundItem(id,type,isShow) {
                return getInboundDetail({inboundNo:id}).then((res)=>{
                    if(res.status===200){
                        if(type=="self"){
                            this.selfConfirm.inboundNo = id;
                            this.selfConfirm.productName = res.result.productName;
                            this.selfConfirm.company = res.result.userName;
                            this.selfConfirm.price = res.result.price;
                            this.selfConfirm.num = res.result.num;
                            this.selfConfirm.leftNum = res.result.leftNum;
                            this.selfConfirm.warehouse = res.result.warehouse;
                            this.selfConfirmVisible = true;
                        }else{
                            this.text = "";
                            this.warehouseConfirm.inboundNo = id;
                            this.uploadData.inboundNo = id;
                            this.warehouseConfirm.productName = res.result.productName;
                            this.warehouseConfirm.company = res.result.userName;
                            this.warehouseConfirm.price = res.result.price;
                            this.warehouseConfirm.num = res.result.num;
                            this.warehouseConfirm.leftNum = res.result.leftNum;
                            this.warehouseConfirm.warehouse = res.result.warehouse;
                            this.warehouseConfirm.trackingStatus = "All";
                            this.warehouseConfirm.claimedList = res.result.trackingList;
                            this.warehouseConfirm.unClaimedList = res.result.unClaimedTrackingList;
                            this.warehouseConfirm.unMatchedList = res.result.unMatchedTrackingList;
                            this.warehouseConfirm.trackingNumbers = [];
                            this.warehouseConfirm.claimedList.forEach((item)=>{
                                item.confirmed = true;
                                item.matched = true;
                                item.loading = false;
                            })
                            this.warehouseConfirm.unClaimedList.forEach((item)=>{
                                item.confirmed = false;
                                item.matched = true;
                                item.loading = false;
                                item.canClaim = null; // 初始化为null，后续异步检查
                            })

                            // 异步检查每个tracking是否可以被claim（UPC验证）
                            this.checkTrackingClaimability(id);
                            this.warehouseConfirm.unMatchedList.forEach((item)=>{
                                item.confirmed = false;
                                item.matched = false;
                                item.loading = false;
                            })
                            // 确保重新组合前清空数组，避免重复显示
                            this.warehouseConfirm.trackingNumbers = [
                                ...this.warehouseConfirm.unClaimedList,
                                ...this.warehouseConfirm.unMatchedList,
                                ...this.warehouseConfirm.claimedList
                            ];
                            this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice(0,100)
                            this.warehouseConfirm.total = this.warehouseConfirm.trackingNumbers.length;
                            this.warehouseConfirm.currentPage = 1
                            if(isShow){
                                this.warehouseConfirmVisible = true;
                            }
                        }

                    }else{
                        this.$message.error(res.message);
                    }
                })
                // this.selfConfirm = row;
                // this.selfConfirmVisible = true;
            },
            handleSelectionChange(val) {
                this.removeMultipleSelection = "";
                for (let i = 0; i < val.length; i++) {
                    let item = val[i];
                    if (i > 0) {
                        this.removeMultipleSelection = this.removeMultipleSelection + "," + item.tracking;
                    } else {
                        // 第一个选中时，不用在前面加逗号
                        this.removeMultipleSelection = item.tracking;
                    }
                }
            },
            changeImportTrackingPage(val){
                this.warehouseConfirm.currentPage = val;
                this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice((val-1)*100,val*100)
            },
            changeTrackingFilterStatus(){
                let status = this.warehouseConfirm.trackingStatus;
                // 根据状态筛选显示不同的tracking数据
                if(status=="All"){
                    this.warehouseConfirm.trackingNumbers = [
                        ...this.warehouseConfirm.unClaimedList,
                        ...this.warehouseConfirm.unMatchedList,
                        ...this.warehouseConfirm.claimedList
                    ];
                }else if(status=="Claimed"){
                    this.warehouseConfirm.trackingNumbers = [...this.warehouseConfirm.claimedList];
                }else if(status=="Matched"){
                    this.warehouseConfirm.trackingNumbers = [...this.warehouseConfirm.unClaimedList];
                }else if(status=="Unmatched"){
                    this.warehouseConfirm.trackingNumbers = [...this.warehouseConfirm.unMatchedList];
                }
                this.warehouseConfirm.trackingNumbersPage = this.warehouseConfirm.trackingNumbers.slice(0,100)
                this.warehouseConfirm.total = this.warehouseConfirm.trackingNumbers.length;
                this.warehouseConfirm.currentPage = 1
            },
            getReportList() {
                let param ={
                    current:this.reportPage,
                    size:this.pageSize,
                    condition:this.filters.reportFilter,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                    status:this.filters.reportStatus
                }
                this.secondListLoading = true;
                getInventoryReportList(param).then((data) => {
                    this.secondListLoading = false;
                    if(data.status===200){
                        this.reportedInbound = data.result.records;
                        this.reportTotal = data.result.total;
                    }
                })
            },
            getInboundHistoryList() {
                this.thirdListLoading= true;
                let param = {
                    current:this.historyPage,
                    size:this.pageSize,
                    productName:this.filters.historyFilter,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                }
                getInboundHistoryList(param).then((data) => {
                    this.thirdListLoading = false;
                    if(data.status===200){
                        this.inboundHistory = data.result.records;
                        this.historyTotal = data.result.total;
                    }
                })
            },
            getNurseConfirmList() {
                let param = {
                    current:this.confirmInboundPage,
                    size:this.pageSize,
                    condition:this.filters.confirmInboundFilter,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                    status:0
                };
                this.firstListLoading = true;
                getNurseConfirmList(param).then((data) => {
                    this.firstListLoading = false;
                    if(data.status===200){
                        this.confirmInbound = data.result.records;
                        this.confirmInboundTotal = data.result.total;
                    }
                })
            }
        },
        mounted() {
            this.getReportList();
            this.getInboundHistoryList();
            this.getNurseConfirmList();
        }
    }

</script>


// WEBPACK FOOTER //
// Inbound.vue?567009bf